import { render } from "./ReservationHeader.vue?vue&type=template&id=674d2d4a"
import script from "./ReservationHeader.vue?vue&type=script&lang=js"
export * from "./ReservationHeader.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__